import React from 'react';
import './Header.css';

const Header = () => {
  const handleJoinClick = (e) => {
    e.preventDefault();
    const form = document.getElementById('waitlist');
    if (!form) return;
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => {
      const input = form.querySelector('input[type="email"]');
      if (input) input.focus();
    }, 600);
  };

  return (
    <header className="header">
      <div className="header-container">
        <span className="logo-text">RentWise</span>
        <a href="#waitlist" className="header-cta-btn" onClick={handleJoinClick}>Join the Movement</a>
      </div>
    </header>
  );
};

export default Header;
